import { Image, Col, Container, Row, Button } from 'react-bootstrap';
// import { readBuilderProgram } from 'typescript';
import './About.css'
import Ship from '../Ship';

export const About: React.FC = () => {
    return (
        <div id="about">
            <Container className="containBack justify-content-center p-0" >
                <Ship />
                
                <Row className="white mt-4 mx-4">
                    <p className="cooperb mt-4" style={{fontSize: "2rem"}}>About Us</p>
                    <Col xs={12} lg={8} className="px-0 px-lg-1">
                    <p className="cooperl px-2" style={{fontSize: "1.5rem", lineHeight: "2rem", textAlign: "justify"}}>
                        The LaFiura family and partners in <span style={{fontWeight: "bold"}}>Sauce</span> have been part of the Pleasant Valley community for 23 years. We have worked here & raised our children here. We have been serving the West End and 
                        surrounding communities for the past 8 years with our ormer food cart pop up business <span style={{fontWeight: "bold"}}>"Rice Around The World"</span> creating authentic rice dishes and mor from around the globe.
                        Opening a locally based restaurant has been a dream for many years. We invite you to bring your family and friends, relax in our indoor dining area or on our outdoor patio, and enjoy the beauty that the Pocono's offers.
                        Come on out... let us cook for you!
                    </p>
                    </Col>
                    <Col xs={12} lg={4}>
                        <Image width="100%" height="auto" src="./outside.png" alt="outside" />
                    </Col>
                </Row>
                <Row className="white">
                    <Col xs={12} lg={4}><Image width="100%" height="100%" src="about1.png" ></Image></Col>
                    <Col xs={12} lg={4}><Image width="100%" height="100%" src="about2.png" ></Image></Col>
                    <Col xs={12} lg={4}><Image width="100%" height="100%" src="about3.png" ></Image></Col>
                </Row>
            </Container>
            <Row className="justify-content-center text-align-center text-white" style={{width: '100%'}}>
                <div className="footer mt-5">
                <h5>
                    109 Marshall Lane
                    Brodheadsville Pa 18322
                    (570) 994-4134
                </h5>
                </div>
            </Row>
        </div>
    )
}